import LoginNavLoginPage from './LoginNav_LoginPage';
import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert,Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { postDataLogin } from '../ApiServices/ApiService';
import { useNavigate,useLocation } from 'react-router-dom';

const  MultiFactorAuthentication = () => {

  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const emailTemp = location.state?.email || "";
  console.log("emailTemp", emailTemp);
//   const [email, setEmail] = useState(emailTemp)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if(!code){
      setError('Please Enter MFA Code.');
      return;
    }
    setLoading(true);
    const payload = {
        "op": "VERIFY-OTP",
        "email":emailTemp,
        "otp": code
    }

    try {
      await postDataLogin('/admin/verify_otp',payload).then(resp => {
        if(resp.statusCode === 200){
          if(resp.message.toLowerCase() === 'success'){
            // const orgID=resp.dataJ.organization_id
            // localStorage.setItem("org_id",orgID)
            // setTimeout(() => {
              setLoading(false);
              navigate("/job-post");
            // }, 3000);

          }else{
            setLoading(false);
            setError(resp.info); 
          }
       
        }else if(resp.statusCode === 500){
          setLoading(false);
          setError(resp.info);        
        }else{
          setLoading(false);
          setError('Login failed. Please check your OTP.');
        }
      }).catch((error) => {
        setLoading(false);
        setError('Login failed. Please check your OTP or Network Error');
        console.log('network error:', error);
      });
    } catch (error) {
      setLoading(false);
      setError('Login failed. Please check your OTP or Network Error');
      // Handle login error, e.g., display an error message to the user.
      console.error('Login failed', error);
    }


    // Your login logic goes here
    // For simplicity, I'll just show a success message
    // setSuccess('Login successful!');
  };

  const handleCancle = () =>{
    navigate("/login"); 
  }

  return (
    // <>
    // <LoginNavLoginPage></LoginNavLoginPage>
    // <form onSubmit={handleSubmit}>
    //   <label>
    //     Enter MFA Code:
    //     <input
    //       type="text"
    //       value={code}
    //       onChange={(e) => setCode(e.target.value)}
    //     />
    //   </label>
    //   <Button type="submit" variant='dark'>Submit</Button>
    // </form>
    // </>
    <div>
    
    <LoginNavLoginPage></LoginNavLoginPage>
      
      <div className="login-page-container">
      <div className='w-100'>
      <h4 style={{display:'flex', justifyContent:'center',color: '#345687'}}>Multi-Factor Authentication : </h4>
      <Container className='mainContainer'>
      <div className='formContainer container-width' style={{width:'100%', maxWidth:'500px'}}>
      <Row >
        <Col md={12}>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="danger">{success}</Alert>}
          <Form className="Form" onSubmit={handleSubmit}>

            <Form.Group className='input-box margin-bottom'>
              <Form.Control
                type="text"
                placeholder="Enter MFA Code To Complete Sign-In"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className="placehold-padding"
              />
            </Form.Group>

            <Button variant="dark" type="submit" className="Button" style={{marginBottom:'15px'}}>
              Submit
            </Button>
            <p className="Links__paragraph forgot-p-sty" onClick ={handleCancle} >
            Cancel
            </p>
            {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
          </Form>
           
          
        </Col>
      </Row>
      </div>
      </Container>
      </div>
    </div>
    </div>
  );
}

export default MultiFactorAuthentication;